<template>
  <div>
    <component :is="componentName"></component>
  </div>
</template>
<script>
  import caseDetail from '@/page/case/recordList.vue'
  import academyDetail from '@/page/academy/recordList.vue'
  import otcDetail from '@/page/otc/recordList.vue'
  import kshDetail from '@/page/ksh/recordList.vue'
  import hjhDetail from '@/page/hjh/recordList.vue'
  import surveyDetail from '@/page/survey/recordList.vue'
  import yshSurveyDetail from '@/page/yshSurvey/recordList.vue'
  import lvlHospitalDetail from '@/page/lvlHospital/recordList.vue'
  import baseHospitalDetail from '@/page/baseHospital/recordList.vue'
  export default {
    components: {
      caseDetail,
      academyDetail,
      otcDetail,
      kshDetail,
      hjhDetail,
      surveyDetail,
      yshSurveyDetail,
      lvlHospitalDetail,
      baseHospitalDetail
    },
    data() {
      return {
        type: localStorage.projectType,
        componentName: ''
      }
    },
    watch: {
      type: {
        immediate: true,
        handler(val) {
          if (val == 5) { // 1学术拜访  2 OTC巡访  3 科室会  4 患教会 5病例 6ysh调查问卷 7助手调查问卷
            this.componentName = 'caseDetail'
          } else if (val == 1) {
            this.componentName = 'academyDetail'
          } else if (val == 2) {
            this.componentName = 'otcDetail'
          } else if (val == 3) {
            this.componentName = 'kshDetail'
          } else if (val == 4) {
            this.componentName = 'hjhDetail'
          } else if (val == 7) {
            this.componentName = 'surveyDetail'
          } else if (val == 6) {
            this.componentName = 'yshSurveyDetail'
          } else if (val == 9) {
            this.componentName = 'lvlHospitalDetail'
          } else if (val == 10) {
            this.componentName = 'baseHospitalDetail'
          }
        }
      }
    },
    created() {
      let val = localStorage.projectType
      if (val == 5) { // 1学术拜访  2 OTC巡访  3 科室会  4 患教会 5病例 6ysh调查问卷 7助手调查问卷
        this.componentName = 'caseDetail'
      } else if (val == 1) {
        this.componentName = 'academyDetail'
      } else if (val == 2) {
        this.componentName = 'otcDetail'
      } else if (val == 3) {
        this.componentName = 'kshDetail'
      } else if (val == 4) {
        this.componentName = 'hjhDetail'
      } else if (val == 7) {
        this.componentName = 'surveyDetail'
      } else if (val == 6) {
        this.componentName = 'yshSurveyDetail'
      }
    }
  }

</script>
